import React, {Component} from 'react';
import {Container, Col, Form, Button, Row, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import {Bar} from '../bar/Bar';

class Products extends Component{
    constructor(){
        super();
        this.state = {
            products: [],
            productsMonth: [],
            pageProducts: 0,
            counterProducts: 0,
            limit: 10,
        }
    }
    
    componentDidMount(){
        try{
            this.fetchData(0)
        }
        catch(ex){

        }
    }
    /* Downlading data function from API */
    fetchData(page){
        const token = localStorage.getItem('JWT-token');
        var year = localStorage.getItem('year-date');
        var month = localStorage.getItem('month-date');
        var monthTo = Number(month);
        monthTo += 1;
        fetch(process.env.REACT_APP_API + 'product' 
        + `?dateFrom=2015-01-01`
        + `&dateTo=${year}-${monthTo}-01`
        + `&limit=${this.state.limit}`
        + `&page=${page}`
        ,{
            method:'GET',
            mode: 'cors',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': `Bearer ${token}`
            },
        })
        .then(res=>res.json())
        .then((res)=>{
            this.setState({products: res.result, productsMonth: res.headerResults});
        })
        .catch((ex)=>(
            console.log(ex)
        ))
    }
    /* Increment Pageing function */
    increment() {
        this.setState((prevState) => {
            let prev = prevState.pageProducts;
            let counterPrev = prevState.counterProducts;
            prev = prev + 10;
            counterPrev = counterPrev + 1;
            try{this.fetchData(prev)}catch(ex){return("Brak danych.")}
            return { pageProducts: prev, counterProducts: counterPrev};
        })
    }
    /* Decrement Pageing function */
    decrement() {
        this.setState((prevState) => {
            let prev = prevState.pageProducts;
            let counterPrev = prevState.counterProducts;
            prev = prev - 10;
            counterPrev = counterPrev - 1;
            if(prev < 0) prev=0;
            if(counterPrev < 0) counterPrev=0;
            try{this.fetchData(prev)}catch(ex){return("Brak danych.")}
            return { pageProducts: prev, counterProducts: counterPrev };
        })
    }
    /* Render table of products */
    renderTableProducts(type){
        var data = this.state.products;
        var monthTotal = this.state.productsMonth;

        var monthList = data.map((e)=>(e.results.map((res) => (res.column != "sum" ? res.column : null)).filter(elem => elem != null)));
        var months = monthList[0]

        if(type=="productsTable"){
        return(
            <table className="table table-striped custom-table CRM-client-table col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <thead>
                    <tr>
                        <th className="headcol">
                            Produkt
                        </th>
                        {months != null ? months.map((e, index)=>{
                            return(
                                <td key={index}>
                                    {e} |
                                </td>
                            )
                        }) : ''}
                        <td  className="long">
                        </td>
                        <td  className="long">
                            <b>Stan mag.</b>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    {data.map((product) => (
                        <tr>
                            <th className="headcol">
                                {product.name}
                            </th>
                            {product.results.map((res) => (     
                                <td className="long">
                                    {res.result} 
                                </td>
                            ))}
                            
                            <td className="long">
                                {product.results.map((res)=>(<b>{res.sum}</b>))}
                            </td>
                           
                        </tr>
                     ))}

                </tbody>
            </table>
        )
        }

        if(type=="sum"){
        return(
            <table className="table table-striped custom-table CRM-client-table col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <thead>
                    <tr>
                        <th className="headcol" id="monthCRMTotal">
                            Sumy miesięczne produktów
                        </th>
                        {months != null ? months.map((e, index)=>{
                            return(
                                <td key={index}>
                                    {e} |
                                </td>
                            )
                        }) : ''}
                        <td  className="long">
                        </td>
                        <td  className="long">
                            <b>-----------</b>
                        </td>
                    </tr>
                </thead>            
                <tbody>
                    <tr>
                        <th className="headcol">
                            Suma miesięczna
                        </th>
                        {monthTotal.map((month) => (
                            <td className="long">
                                {month.result} 
                            </td>
                        ))}
                    </tr>

                </tbody>
            </table>
        )
        }
    }
    /* Render content of page */
    content(){
        return(
            <div className="container-main col-xs-12 col-lg-12 col-md-12 col-sm-12">
                <Col className="row-main col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <Row>  
                        <div className="container CRM-client-table-new" id="Select1">
                            <h2>Produkty</h2><br/>
                            <div className="table-responsive">
                                {this.renderTableProducts("productsTable")}
                                    <br/>
                                {this.renderTableProducts("sum")}
                            </div>
                        </div>
                        <div className='btn-crm'>
                            <Button 
                                onClick={this.decrement.bind(this)} 
                                className='pagination-btn'
                            >
                                Poprzednia
                            </Button> 
                            <span className='pagination-main'>
                                Strona {this.state.counterProducts+1}. 
                            </span>
                            <Button 
                                onClick={this.increment.bind(this)} 
                                className='pagination-btn'
                            >
                                Następna
                            </Button>
                        </div>
                   </Row>
                </Col>
            </div>  
        )
    }    
    /* Main function */
    render(){
        if(localStorage.getItem("JWT-token") == null ||
           localStorage.getItem("JWT-token") == undefined ||
           localStorage.getItem("month-date") == null ||
           localStorage.getItem("month-date") == undefined ||
           localStorage.getItem("month-date") == '')
           {
            return window.location = '/wybierz-date'
           }
        else{
            return(
                <>
                    <Bar/>
                    {this.content()}
                </>
            )
        }
    }
}
export default Products;